import objectPath from 'object-path'
import { loadByGET, loadByPOST } from '../../../action/Table'
import { checkCrudCondition } from '../action/Crud'
import { cancelDebounceCallback } from 'utility/debounceCallback.util'

export const createPaginationActionHelper = ({
  tableRef,
  uischema,
  propTable,
  tableData,
  isLoadGET,
  isLoadPOST,
  isLoadApiGET,
  isLoadSEARCH,
  isLoadTABLE,
  isLoadJSON,
  search,
  designContext,
  allParams,
  setPage,
  setRowsPerPage,
  setPageData,
  setLoading,
  setIsRenderTable,
  tableDebounceName,
}) => {
  const handleChangeRowsPerPage = async (event) => {
    tableRef.current.onRowsPerPageChange(event)
    let { get, post } = uischema?.loadData || {}
    let nextPageData = { page: 0, rowsPerPage: event.target.value }
    let prop = {
      ...propTable,
      uischema: uischema,
      pagination: {
        page: nextPageData.page + 1,
        rowsPerPage: nextPageData.rowsPerPage,
      },
    }
    let newTableData = tableData
    if (isLoadGET && get.enablePagination) {
      newTableData = await loadByGET(get, prop, designContext)
    } else if (isLoadPOST && post.enablePagination) {
      newTableData = await loadByPOST(post, prop, designContext)
    } else if (isLoadSEARCH) {
      if (search.enablePagination) {
        cancelDebounceCallback(tableDebounceName)
        newTableData = await loadByGET(search, prop, designContext)
      }
    } else if (isLoadTABLE) {
      let loadTable = objectPath.get(uischema, 'loadData.table')
      newTableData = await loadByGET(
        { ...search, ...loadTable },
        prop,
        designContext,
      )
    } else if (isLoadJSON) {
      setPage(0)
    }
    setRowsPerPage(event.target.value)
    setPageData(nextPageData)
    return newTableData
  }

  const handleChangePage = async (newPage, rowsPerPage) => {
    setLoading(true)
    setPage(newPage)
    setRowsPerPage(rowsPerPage)
    let nextPageData = { page: newPage, rowsPerPage }
    setPageData(nextPageData)
    let { get, apiCondition } = uischema?.loadData || {}
    let prop = {
      ...propTable,
      uischema: uischema,
      pagination: { page: newPage + 1, rowsPerPage: rowsPerPage },
    }
    let newTableData = tableData
    if (isLoadGET) {
      newTableData = await loadByGET(get, prop, designContext)
      if (!get.enablePagination) {
      }
    } else if (isLoadApiGET && apiCondition) {
      let filterApi = checkCrudCondition({
        action: uischema?.loadData,
        designContext,
        allParams,
      })
      if (filterApi?.length > 0) {
        filterApi.forEach((get) => {
          loadByGET(get, prop, designContext, setIsRenderTable)
        })
      } else {
      }
    } else if (isLoadSEARCH) {
      if (search.enablePagination) {
        cancelDebounceCallback(tableDebounceName)
        newTableData = await loadByGET(search, prop, designContext)
      }
    } else if (isLoadTABLE) {
      let loadTable = objectPath.get(uischema, 'loadData.table')
      newTableData = await loadByGET(
        { ...search, ...loadTable },
        prop,
        designContext,
      )
    }
    setLoading(false)
    return newTableData
  }

  return {
    handleChangeRowsPerPage,
    handleChangePage,
  }
}
